
// Testimonials slider ===================//
$(".testimonials-slider").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    infinite:false,
    prevArrow: '<button class="slick-prev slick-arrow"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24 12L16 20L24 28" stroke="#1E1E1E" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square"/><rect x="-0.5" y="0.5" width="39" height="39" rx="19.5" transform="matrix(-1 0 0 1 39 0)" stroke="#1E1E1E"/></svg></button>',
    nextArrow: '<button class="slick-next slick-arrow"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 12L24 20L16 28" stroke="#1E1E1E" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square"/><rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="#1E1E1E"/></svg></button>',
    responsive: [
        {
          breakpoint: 850,
          settings: {
          slidesToShow: 1,
          arrows: false,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding:"8%",
          },
        },
      ],
});


$(".featured-collection-slider").slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: true,
    dots: true,
    infinite:false,
    prevArrow: '<button class="slick-prev slick-arrow"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24 12L16 20L24 28" stroke="#1E1E1E" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square"/><rect x="-0.5" y="0.5" width="39" height="39" rx="19.5" transform="matrix(-1 0 0 1 39 0)" stroke="#1E1E1E"/></svg></button>',
    nextArrow: '<button class="slick-next slick-arrow"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 12L24 20L16 28" stroke="#1E1E1E" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square"/><rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="#1E1E1E"/></svg></button>',
    responsive: [
        {
          breakpoint: 990,
          settings: {
          slidesToShow: 2,
          arrows: false,
          slidesToScroll: 2,
          },
        },
      ],
});



$(".custom-columns-wrapper").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    infinite:false,
    prevArrow: '<button class="slick-prev slick-arrow"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24 12L16 20L24 28" stroke="#1E1E1E" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square"/><rect x="-0.5" y="0.5" width="39" height="39" rx="19.5" transform="matrix(-1 0 0 1 39 0)" stroke="#1E1E1E"/></svg></button>',
    nextArrow: '<button class="slick-next slick-arrow"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 12L24 20L16 28" stroke="#1E1E1E" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square"/><rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="#1E1E1E"/></svg></button>',
    responsive: [
        {
          breakpoint: 750,
          settings: {
          slidesToShow: 1,
          arrows: false,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding:"5%",
          },
        },
      ],
});

window.onload = function() {
  $(".recommendations-slider").slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: true,
    dots: true,
    infinite: false,
    prevArrow: '<button class="slick-prev slick-arrow"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24 12L16 20L24 28" stroke="#1E1E1E" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square"/><rect x="-0.5" y="0.5" width="39" height="39" rx="19.5" transform="matrix(-1 0 0 1 39 0)" stroke="#1E1E1E"/></svg></button>',
    nextArrow: '<button class="slick-next slick-arrow"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 12L24 20L16 28" stroke="#1E1E1E" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square"/><rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="#1E1E1E"/></svg></button>',
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
          arrows: false,
          slidesToScroll: 2,
        },
      },
    ],
  });
};




function checkBreakPoint() {
	w = $(window).width();
	if (w <= 750) {
		$('.custom-columns-no-slider-wrapper').not('.slick-initialized').slick({
            slidesToShow: 1,
            infinite:false,
            arrows: false,
            dots: true,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding:"5%",
		});

        $('.grid--blog').not('.slick-initialized').slick({
            slidesToShow: 1,
            infinite:false,
            arrows: false,
            dots: true,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding:"5%",
		});
	} else {
		$('.custom-columns-no-slider-wrapper').slick('unslick');
        $('.grid--blog').slick('unslick');
	}


}
// Check every window size change
$(window).resize(function(){
	checkBreakPoint();
});
// Initial check
checkBreakPoint();





